import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import WalletProvider from "./contexts/WalletProvider";
import {BrowserRouter} from "react-router-dom";
import AlertProvider from "./contexts/AlertProvider";
import Mp3PlayerProvider from "./contexts/mp3Provider";
import ModalProvider from "./contexts/ModalProvider";
import {HelmetProvider} from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <WalletProvider>
        <AlertProvider>
          <Mp3PlayerProvider>
            <ModalProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </ModalProvider>
          </Mp3PlayerProvider>
        </AlertProvider>
      </WalletProvider>
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
